import React, { Component, Fragment, useState, useEffect } from "react";
import { Button } from "reactstrap";
import BarChart from "./Components/BarChart";
import RadarChart from "./Components/RadarChart";
import Mixed from "./Components/Mixed";
import { useHistory } from "react-router-dom";

import Circle from "react-circle";

import { Row, Col, Card } from "reactstrap";

import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import FiscalIndicator from "./Module/FiscalIndicator";
import IncomeTransition from "./Module/IncomeTransition";
import ReviewReport from "./Components/ReviewReport";
import { sendGAEvent } from "../../../utils";

const AnalyticsOrgDashboard = ({ orgId, data, refetch }) => {
  if ("このユーザーは団体と紐づいていません" == orgId) {
    window.location.href = "/#/dashboards/faq";
  }
  const history = useHistory();

  const fiscalIndicator = [
    "寄付・会費率",
    "事業収入比率",
    "社会的支援収入比率",
    "収入多様性指標",
    "管理費比率",
    // "支払可能期間",
    "正味財産・収益比率",
    "収益率",
  ];

  // 組織診断して戻ってきたらRefetchしてデータを更新する
  if (window.location.href.includes("?doneDiagnose")) {
    refetch();
    window.location.href = "/#/dashboards/analytics";
  }

  const { allAnnualData } = data;

  const newestAnnualData =
    allAnnualData &&
    allAnnualData.edges &&
    allAnnualData.edges[allAnnualData.edges.length - 1];

  const fiscalIndicatorVal = [];
  fiscalIndicatorVal.push(
    newestAnnualData &&
      newestAnnualData.node.socialSupportRevenueRatioMemberDonation
  );
  fiscalIndicatorVal.push(
    newestAnnualData && newestAnnualData.node.projectRevenueRatio
  );
  fiscalIndicatorVal.push(
    newestAnnualData &&
      newestAnnualData.node.socialSupportRevenueRatioMemberDonationSubsidies
  );
  fiscalIndicatorVal.push(newestAnnualData && newestAnnualData.node.hhi);
  fiscalIndicatorVal.push(
    newestAnnualData && newestAnnualData.node.administrativeExpenseRatio
  );
  // fiscalIndicatorVal.push(newestAnnualData.node.payablePeriod);
  fiscalIndicatorVal.push(
    newestAnnualData && newestAnnualData.node.ratioNetAssetsRevenue
  );
  fiscalIndicatorVal.push(
    newestAnnualData && newestAnnualData.node.revenueRatio
  );

  const incomeAnnualData =
    allAnnualData &&
    allAnnualData.edges &&
    allAnnualData.edges.map((array) => array);

  //表示チャート切り替え
  const [financialRatio, setFinantialRatio] = useState("");
  const [sidebar, setSidebar] = useState("incomeTransition");
  const [isFirst, setIsFirst] = useState(0);
  const [chart, setChart] = useState(
    <Mixed incomeAnnualData={incomeAnnualData} />
  );

  useEffect(() => {
    if (isFirst) {
      setChart(
        <BarChart
          financialRatio={financialRatio}
          fiscalYearData={fiscalYearData}
        />
      );
    } else {
      refetch(allAnnualData);
    }
  }, [financialRatio]);

  const fiscalYearData = data.allAnnualData.edges.map(
    (array) => array.node.fiscalYear
  );

  //診断結果の数値合計
  const diagnoseResultTotal = data.diagnoseResult.valueList.reduce(
    (sum, i) => sum + i,
    0
  );

  // Get width of browser
  const getWidth = () => {
    if (window.innerWidth) {
      return window.innerWidth;
    } else if (document.body && document.body.clientWidth) {
      return document.body.clientWidth;
    } else if (
      document.documentElement &&
      document.documentElement.clientWidth
    ) {
      return document.documentElement.clientWidth;
    }
    return 0;
  };

  let diagnose = {"margin": "auto", "font-weight": "bold"}

  return (
    <div>
      <div className="analytics_head">
        <div
          className="rightarea-2"
          style={{
            display: "flex",
            ...(diagnoseResultTotal !== 0 && {
              flexDirection: getWidth() < 768 ? "column" : "row",
              marginBottom: "8px",
              ...(getWidth() >= 768 && {
                gap: "16px",
              }),
            }),
          }}
        >
          <Col
            md={diagnoseResultTotal !== 0 ? "12" : "6"}
            lg="4"
            style={{ position: "relative", padding: 0, flexBasis: getWidth() < 1000 ? "49%" : "29%" }}
          >
            <Card
              onClick={() => {
                setIsFirst(1);
                setChart(
                  <RadarChart
                    labels={data.diagnoseResult.quetionCategory}
                    datasets={data.diagnoseResult.valueList}
                    item={"組織診断"}
                  />
                );
              }}
              className="widget-chart widget-chart2 text-left mb-2 card-btm-border card-shadow-warning card_diagnose_result"
              style={{
                borderColor: "#44CAE1",
                position: "relative",
                zIndex: 10,
              }}
            >
              <div className="widget-chat-wrapper-outer pointer">
                <div className="widget-chart-content">
                  <div className="widget-title opacity-5 text-uppercase">
                    組織診断結果
                  </div>
                  <div className="widget-numbers mt-2 fsize-4 mb-0 w-100">
                    <div className="widget-chart-flex align-items-center">
                      <div>
                        <span
                          className="opacity-10 pr-2"
                          style={{ color: "#44CAE1" }}
                        >
                          <FontAwesomeIcon icon={faAngleUp} />
                        </span>
                        {Math.floor(
                          (diagnoseResultTotal /
                            data.diagnoseResult.valueList.length) *
                            100
                        ) / 100}
                      </div>
                      <div className="ml-auto">
                        <Circle
                          animate={true} // Boolean: Animated/Static progress
                          animationDuration="10s" // String: Length of animation
                          responsive={false} // Boolean: Make SVG adapt to parent size
                          size="46" // String: Defines the size of the circle.
                          lineWidth="30" // String: Defines the thickness of the circle's stroke.
                          progress={
                            Math.floor(
                              (diagnoseResultTotal /
                                data.diagnoseResult.valueList.length) *
                                100
                            ) / 100
                          } // String: Update to change the progress and percentage.
                          progressColor="#44CAE1" // String: Color of "progress" portion of circle.
                          bgColor="#44CAE1" // String: Color of "empty" portion of circle.
                          textColor="#6b778c" // String: Color of percentage text color.
                          textStyle={{
                            fontSize: "6rem", // CSSProperties: Custom styling for percentage.
                          }}
                          percentSpacing={5} // Number: Adjust spacing of "%" symbol and number.
                          roundedStroke={true} // Boolean: Rounded/Flat line ends
                          showPercentage={true} // Boolean: Show/hide percentage.
                          showPercentageSymbol={false} // Boolean: Show/hide only the "%" symbol.
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
            {diagnoseResultTotal === 0 && (
              <Card
                // 22.6.29 診断内容整ったらコメントアウト外す
                onClick={(e) => {
                  history.push("evaluation");
                }}
                className="cartToDiagnose pointer"
                style={{
                  left: "0",
                }}
              >
                <div className="contents" style={diagnose}>
                  <div className="text">組織診断をする</div>
                </div>
              </Card>
            )}
          </Col>
          <Col
            md={diagnoseResultTotal !== 0 ? "12" : "6"}
            lg="4"
            onClick={() => {
              setIsFirst(1);
              setChart(<ReviewReport />);
              setSidebar("incomeTransition");
              sendGAEvent("pageview", "/#/dashboards/analytics/nps_tab");
            }}
            className="pointer"
            style={{
              flexBasis: "49%",
              ...(diagnoseResultTotal !== 0 && {
                paddingLeft: "0",
                paddingRight: "0",
              }),
            }}
          >
            <Card
              className="cardtitle nps-card"
              style={{
                backgroundColor: " #44cae1",
                color: "#fff",
                height: "111px",
                padding: "1rem",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
              }}
            >
              <div>NPS</div>
            </Card>
          </Col>
        </div>
        <Row className="mb-2 rightarea">
          {/* イニシャルに収入推移をセットしている */}
          <Col
            md="6"
            lg="6"
            onClick={() => {
              setIsFirst(1);
              setChart(<Mixed incomeAnnualData={incomeAnnualData} />);
              setSidebar("incomeTransition");
              sendGAEvent(
                "pageview",
                "/#/dashboards/analytics/revenue_trend_tab"
              );
            }}
            className="pointer"
          >
            <Card className="cardtitle">
              <div>収入推移</div>
            </Card>
          </Col>
          <Col
            md="6"
            lg="6"
            onClick={() => {
              setIsFirst(1);
              setChart(
                <RadarChart
                  labels={fiscalIndicator}
                  datasets={fiscalIndicatorVal}
                  item={"財務指標"}
                />
              );
              setSidebar("fiscalIndicator");
              sendGAEvent(
                "pageview",
                "/#/dashboards/analytics/financial_indicator_tab"
              );
            }}
            className="pointer"
          >
            <Card className="cardtitle">財務指標</Card>
          </Col>
        </Row>
      </div>
      <div className="an_board_contents">
        <div className="left">
          {/* <RadarChart />
              <BarChart /> */}
          {chart}
        </div>

        <div className="right">
          <div>
            {sidebar === "fiscalIndicator" ? (
              <FiscalIndicator
                data={data}
                setFinantialRatio={setFinantialRatio}
                setIsFirst={setIsFirst}
              />
            ) : (
              <IncomeTransition
                data={data}
                setFinantialRatio={setFinantialRatio}
                setIsFirst={setIsFirst}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsOrgDashboard;
